
<div class="verification-backdrop d-print-none" *ngIf="open && !embedded" (click)="close()"></div>
<aside
  class="verification-drawer d-print-none"
  [class.verification-drawer-embedded]="embedded"
  *ngIf="open"
  aria-label="Document verification"
>
  <div class="verification-drawer-header" *ngIf="!embedded">
    <div>
      <div class="text-secondary small">Business document</div>
      <h3 class="m-0">Verification</h3>
    </div>
    <button type="button" class="btn btn-sm btn-icon" aria-label="Close verification" (click)="close()">×</button>
  </div>

  <div class="verification-drawer-body">
    <div class="alert alert-info" *ngIf="!requests.length">
      This step has no active verification request.
    </div>

    <div class="mb-3" *ngFor="let request of requests">
      <strong>{{ text(request['group_name']) || 'Review group' }}</strong>
      <div class="text-secondary small">
        {{ request['received_approvals'] || 0 }} of {{ request['required_approvals'] || 0 }} approvals
      </div>
      <label class="form-label mt-2" [for]="'drawer-verification-note-' + request['id']">Decision comment</label>
      <textarea class="form-control" rows="2" [id]="'drawer-verification-note-' + request['id']"
        [(ngModel)]="decisionNotes[text(request['id'])]"
        placeholder="Add context, especially when requesting changes"></textarea>
      <div class="btn-list mt-2">
        <button type="button" class="btn btn-primary btn-sm"
          [disabled]="pendingRequestId === request['id'] || request['has_decided']"
          (click)="decide(request, 'approved')">Approve</button>
        <button type="button" class="btn btn-sm"
          [disabled]="pendingRequestId === request['id'] || !decisionNotes[text(request['id'])]?.trim()"
          (click)="decide(request, 'changes_requested')">Request changes</button>
      </div>
    </div>

    <hr>
    <h4>Conversation</h4>
    <div class="text-secondary py-3" *ngIf="loading">Loading notes…</div>
    <div class="verification-note" *ngFor="let note of notes">
      <div>{{ text(note['body']) }}</div>
      <div class="text-secondary small">{{ text(note['created_at']) | utcToLocal }}</div>
    </div>

    <label class="form-label mt-3" for="verification-request">Related review</label>
    <select id="verification-request" class="form-select" [(ngModel)]="selectedRequestId">
      <option value="">General document note</option>
      <option *ngFor="let request of requests" [value]="request['id']">
        {{ text(request['group_name']) || 'Review group' }}
      </option>
    </select>
    <small class="form-hint">Choose a review group or leave this as a document-wide note.</small>

    <label class="form-label mt-3" for="verification-note">Add a note</label>
    <textarea
      id="verification-note"
      class="form-control"
      rows="4"
      [(ngModel)]="noteBody"
      placeholder="Write a review note or reply"
    ></textarea>
    <small class="form-hint">Everyone who can review this document can see this conversation.</small>
    <button
      type="button"
      class="btn btn-primary mt-3"
      [disabled]="saving || !noteBody.trim()"
      (click)="addNote()"
    >
      Add note
    </button>
  </div>
</aside>
